import React, { createContext, useState, useContext } from 'react';

const ConfirmDialogContext = createContext();

export const useConfirmDialog = () => useContext(ConfirmDialogContext);

export const ConfirmDialogProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [onConfirm, setOnConfirm] = useState(() => {});
  const [options, setOptions] = useState({});
  

  const showConfirmDialog = (message, onConfirm, options = {}) => {
    const defaults = {
      title: 'Confirm Action',
      confirmText: 'OK',
      cancelText: 'Cancel'
    };
    setOptions({ ...defaults, ...options });
    setMessage(message);
    setOnConfirm(() => onConfirm);
    setIsOpen(true);
  };

  const handleConfirm = () => {
    onConfirm();
    setIsOpen(false);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <ConfirmDialogContext.Provider value={{ isOpen, message, showConfirmDialog, handleConfirm, handleCancel, options }}>
      {children}
    </ConfirmDialogContext.Provider>
  );
};
